// extracted by mini-css-extract-plugin
export default {"imageContainer":"u2-z","summaryPar":"v2-z","ratingCategories":"w2-z","reviewerInfo":"x2-z","reviewTypes":"y2-z","expanded":"z2-z"};